import styled from 'styled-components/macro'

export const AlertWrapper = styled.div`
  max-width: 460px;
  width: 100%;
`
